export const API_URL= 'https://api.staging.retteweb.f2.net'

export const TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNTg5MzgzMTQ4LCJqdGkiOiI2MTI3NzUwZjExNDA0YTllODIwZjk0MjkxNmU1OWQ0OSIsInVzZXJfaWQiOjJ9.WWqTQj9zalL5WaNtTV69Mfnakk4e3eSFjhtdY1xZk0k'